<template>
  <div class="plan_duration">
    <v-card max-width="724" flat class="mx-auto b-rad-20 pa-4">
      <template v-if="plan">
        <v-card-title>{{ $t('PLAN.COPYWRITING.BILLING_METHOD') }}</v-card-title>
        <v-card-text>
          <v-radio-group
            :value="pickedDay"
            class="mr-2"
            @change="(v) => $emit('update:pickedDay', v)"
          >
            <v-radio
              v-for="day in days"
              :key="day.text"
              :value="day.value"
              class="pa-5"
            >
              <template #label v-if="getPlan(plan, day) != undefined">
                {{ day.text }} {{ $t('COMMON.WORD.DAYS') }}
                <SizeBox width="24" inline />
                <!-- {{ getPlan(plan, day) }} -->
                <span>NTD$ {{ getPlan(plan, day).totalPrice | currency }}</span>
                <span
                  v-if="!!getPlan(plan, day).discount"
                  class="ml-5"
                  style="text-decoration: line-through; color: #757677"
                >
                  NTD $
                  {{
                    getPlan(plan, day).discount + getPlan(plan, day).totalPrice
                  }}
                </span>
                <label v-if="getPlan(plan, day).discount != 0">
                  {{ $t('COMMON.WORD.SAVES') }} NTD ${{
                    getPlan(plan, day).discount | currency
                  }}
                </label>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>
      </template>
    </v-card>

    <SizeBox height="20" />

    <v-card-actions
      v-if="!!pickedDay"
      class="d-flex justify-end mx-auto"
      style="max-width: 724px"
    >
      <!-- <v-btn width="240" outlined @click="$emit('back')">重選方案</v-btn>

      <SizeBox width="24" inline /> -->

      <v-btn width="120" color="primary" depressed @click="$emit('next')">
        {{ $t('PAYMENT.COPYWRITING.CHECKOUT') }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  props: {
    plans: {
      type: Array,
      default: null
    },
    plan: {
      type: Object,
      default: null
    },
    pickedDay: {
      type: String,
      default: null
    },
    days: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    getPlan(plan, day) {
      return this.plans?.find(
        ({ alias }) => alias === `${plan.alias}-${day.value}`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.plan_duration {
  .v-radio {
    position: relative;
    ::v-deep .v-input--selection-controls__input {
      margin-right: 25px;
    }
    ::v-deep .v-label {
      position: static !important;
      color: #fff;
    }
    label {
      position: absolute;
      left: -3%;
      transform-origin: center right;
      background-color: #ff65e6;
      color: #fff;
      border-radius: 4px;
      font-size: 14px;
      transform: translateX(-100%);
      padding: 5px 10px;
      opacity: 1;
      transition: all 0.2s ease-in-out;
      &:before {
        content: '';
        display: inline-block;
        position: absolute;
        right: 1px;
        top: 50%;
        transform: translate(100%, -50%);
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 0 6px 12px;
        border-color: transparent transparent transparent #ff65e5;
      }
    }
    &.v-item--active {
      &::before {
        opacity: 1;
      }
    }
    &::before {
      content: '';
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 2px solid $primary;
      border-radius: 3px;
      position: absolute;
      opacity: 0;
      transition: all 0.2s ease-in-out;
    }
  }
}
</style>